import React, { useState, useEffect, Fragment } from "react";
import Card from "../Card/index";
import axios from "axios";
import Footer from "../Footer";
import "./index.css";
import paises from "../paises";

const Container = () => {
  const [ip, setIp] = useState(null);
  const [datosClima, setdatosClima] = useState(null);
  const [seleccion, setSeleccion] = useState([{ pais: "" }]);

  if ("geolocation" in navigator) {
    navigator.geolocation.getCurrentPosition(
      function (position) {
        setIp(position.coords.latitude + "," + position.coords.longitude);
      },
      function error() {
        axios
          .get("https://geolocation-db.com/json/")
          .then((res) => setIp(res.data.IPv4))
          .catch((err) => console.log(err));
      }
    );
  }

  useEffect(() => {
    async function obtenerDatos() {
      const req = await axios
        .get(
          `https://api.weatherapi.com/v1/forecast.json?key=ddcaaa7c6323488b8c1182836210104&q=${ip}&days=3&aqi=no&alerts=no&lang=es`
        )
        .then((res) => setdatosClima(res.data))
        .catch((err) => console.log(err));
      return req;
    }
    obtenerDatos();
  }, [ip]);

  const dia = datosClima ? datosClima.current.is_day : 0;

  const onchange = (event) => {
    setSeleccion({ [event.target.name]: event.target.value });
    const key = event.keyCode || event.which;
    if (key === 13) {
      setIp(seleccion.pais);
    }
  };

  return (
    <div className={dia ? "dia" : "noche"}>
      {datosClima ? (
        <Fragment>
          <Card
            text={datosClima ? datosClima.current.temp_c + "°C" : null}
            link={datosClima.current.condition.icon}
            desc={datosClima.location.name+"-"+datosClima.location.region}
            horaLocal={`Hora: ${datosClima.location.localtime.split(" ")[1]}`}
            condition={datosClima.current.condition.text}
            paises={paises}
            onChange={onchange}
            wind={datosClima.current.wind_kph}
            windDir={datosClima.current.wind_dir}
            datosGrafico={datosClima.forecast.forecastday[0].hour.map(
              (ele) => ele.time.split(" ")[1].split(":")[0]
            )}
            datosGraficot={datosClima.forecast.forecastday[0].hour.map((ele) =>
              Math.trunc(ele.temp_c)
            )}
          />
          <Footer hoy={datosClima.forecast.forecastday} />
        </Fragment>
      ) : (
        <div className="load"> Cargando...</div>
      )}
    </div>
  );
};

export default Container;
